import httpConfig from '@/api/config';
import axios from 'axios';
import {Message} from 'element-ui';
import Qs from 'qs'
import router from '@/router/index'

// 文件下载专用，不走 JSON 拦截器
const rawAxios = axios.create()

//创建错误拦截器
axios.interceptors.response.use(function (res) {
  let data = res.data;
  if (data.code === 10007) {
    Message.error({
      message: '您的登录信息不正确，请重新登录',
      onClose: function () {
        localStorage.removeItem('user');
        router.replace({name: 'login'});
      }
    });
    return false;
  }
  if (data.status === 'fail') {
    Message.error({
      message: data.message
    });
    return false;
  }
  return data;
}, function (error) {
  Message.error({
    message: '服务器连接失败，请检查网络。'
  });
  return Promise.reject(error);
});

/**
 * 解析api配置信息
 * @param apiName
 * @returns {{url: string, method: *|string|string|SVGAnimatedEnumeration}}
 */
function parseApiConfig(apiName, domain) {
  let api = httpConfig.apiList[apiName];
  if (!domain) {
    domain = httpConfig.apiDomain;
  }
  let url = domain + api.url;
  url = httpConfig.isHttps ? "https://" + url : "http://" + url;
  let method = api.method;
  return {url, method}
}


/**
 * 构造http请求对象
 * @type {{request: http.request}}
 */
const http = {
  request: function (apiName, params = {},getUrl = false) {
    let apiConfig = parseApiConfig(apiName);
    let axiosConfig = {
      url: apiConfig.url,
      timeout: httpConfig.timeout,
      method: apiConfig.method,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    };
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      params.api_token = user.api_token;
    }
    if (apiName === 'intelligentChat' && apiConfig.method.toLowerCase() === 'post') {
      axiosConfig.headers['Content-Type'] = 'application/json; charset=utf-8'
      axiosConfig.data = JSON.stringify(params)
      axiosConfig.timeout = 120000
    } else if (apiConfig.method.toLowerCase() === 'post') {
      axiosConfig.data = Qs.stringify(params)
    } else {
      axiosConfig.params = params
    }
    if(getUrl){
      let query = "";
      for (const key in params){
        if(key === 'filter'){
          params[key] = JSON.stringify(params[key]);
        }
        query +=key+"="+params[key]+"&";
      }
      return axiosConfig.url + "?"+query;
    }
    return axios(axiosConfig);
  },
  upload: function (formData) {
    let apiConfig = parseApiConfig('upload', httpConfig.fileDomain);
    let axiosConfig = {
      data: formData,
      url: apiConfig.url,
      timeout: httpConfig.timeout,
      method: apiConfig.method,
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    };
    return axios(axiosConfig);
  },
  download: function (apiName, params = {}, filename = 'download.pdf') {
    let apiConfig = parseApiConfig(apiName);
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      params.api_token = user.api_token;
    }
    return rawAxios({
      url: apiConfig.url,
      method: apiConfig.method,
      params: params,
      responseType: 'blob',
      timeout: 120000,
    }).then(async (res) => {
      const blob = res.data
      if (!(blob instanceof Blob) || blob.size === 0) {
        Message.error('下载失败：文件为空')
        return Promise.reject(new Error('empty blob'))
      }

      const header = await blob.slice(0, 5).text()
      if (header.indexOf('%PDF') !== 0) {
        try {
          const text = await blob.text()
          const json = JSON.parse(text)
          Message.error(json.message || '下载失败')
        } catch (e) {
          Message.error('下载失败：返回内容不是有效的 PDF')
        }
        return Promise.reject(new Error('invalid pdf'))
      }

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
      return true
    }).catch(async (err) => {
      if (err.message === 'empty blob' || err.message === 'invalid pdf') {
        return Promise.reject(err)
      }
      if (err.response && err.response.data instanceof Blob) {
        try {
          const text = await err.response.data.text()
          const json = JSON.parse(text)
          Message.error(json.message || '下载失败')
        } catch (e) {
          Message.error('下载失败')
        }
      } else {
        Message.error('下载失败，请重试')
      }
      return Promise.reject(err)
    })
  }
}
export default http;



// WEBPACK FOOTER //
// ./src/api/http.js